module.exports = __webpack_public_path__ + "static/media/search.de9ec215.svg";